import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare } from 'lucide-react';

interface ChatButtonProps {
  onClick: () => void;
}

const ChatButton: React.FC<ChatButtonProps> = ({ onClick }) => {
  return (
    <motion.button
      className="fixed z-50 p-3.5 chat-button-pulse bg-blue-600 text-white rounded-full shadow-lg"
      style={{
        bottom: "1.5rem",
        right: "1.5rem",
      }}
      onClick={onClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0, scale: 0.8, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.8, y: 20 }}
      transition={{ duration: 0.3 }}
      aria-label="Abrir chat com assistente virtual"
      aria-haspopup="dialog"
      aria-expanded="false"
      role="button"
      tabIndex={0}
      title="Clique para conversar com nosso assistente virtual"
      data-testid="chat-button"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <span className="sr-only">Abrir chat com assistente virtual</span>
      <MessageSquare size={24} aria-hidden="true" />
    </motion.button>
  );
};

export default ChatButton;
